import "zone.js";
import { enableProdMode, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from "@angular/core";
import { environment } from "@apps/patient-core/src/app/environments/environment";
import { BugsnagErrorHandler } from "@bugsnag/plugin-angular";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { HttpInterceptorProviders } from "@apps/patient-core/src/app/http-interceptors";
import { CurrencyPipe } from "@angular/common";
import { ConciergeAppInitService } from "./app/services/derived/app-init.service";
import { APP_ROUTES } from "./app/app.routing";
import { ConciergeAppComponent } from "./app/app.component";
import { ConciergePatientActionsService } from "./app/services/derived/patient-actions.service";
import { BasePatientActionsService } from "@apps/patient-core/src/app/services/abstracts/patient-actions.service";
import * as PROVIDERS from "@apps/patient-core/generate-abstract-providers";
import { ConciergeLoginService } from "./app/services/concierge-login.service";
import { ConciergeService } from "./app/services/concierge.service";

if (environment.production) {
  enableProdMode();
}

export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

bootstrapApplication(ConciergeAppComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    HttpInterceptorProviders,
    CurrencyPipe,
    ...PROVIDERS.CONCIERGE_PROVIDERS,
    { provide: BasePatientActionsService, useClass: ConciergePatientActionsService },
    { provide: ConciergeLoginService, useClass: ConciergeLoginService },
    { provide: ConciergeService, useClass: ConciergeService },
    { provide: ErrorHandler, useFactory: errorHandlerFactory },
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
      const appInitService = inject(ConciergeAppInitService);
      return appInitService.init();
    }),
    importProvidersFrom(BrowserModule, BrowserAnimationsModule),
  ],
}).catch((err) => console.error(err));
